<main class="container-fluid container-fluid-limited main-page settings">
    @if(team){
        <div class="settings-sub-header w-100 py-4 border-0">
            <div class="d-md-flex justify-content-between">
                <h1 class="team-selector">
                    <div class="team-selector-label">
                        {{'teamMembers' | translate}}
                    </div>
                    <tm-team-select baseUrl="/setup/teammembers"
                                    permission="admin"
                                    [teamIdFromUrl]="teamId"></tm-team-select>
                    <small class="d-block pt-3">{{ 'teamMembersSetting_description' | translate }} <a href="https://help.teammood.com/teammood-structure/tags-categorization-and-anonymity" target="_blank"> {{'tag_them' | translate }}</a>.</small>
                </h1>
                <div class="d-flex align-items-md-center">
                    <button class="btn btn-primary px-4 mb-1 align-top" (click)="createTeamMember()" data-cy="add-teammember" title="{{'create_teammember' | translate}}">
                        <span class="add-member-btn"><i class="far fa-plus"></i>&nbsp;{{('create_teammember' | translate)}}</span>
                    </button>
                </div>
            </div>
        </div>
        
        <div class="row gx-0 pb-3">
            <div class="col-md-7">
                <div class="input-group">
                    <input type="text" name="quick_filter_search" id="search_teammember" 
                        [(ngModel)]="search_terms" 
                        (ngModelChange)="applyFilters()" 
                        class="form-control mb-1" 
                        placeholder="{{ 'search_teammembers' | translate}}">
                    <span class="icon-addon">
                        @if(search_terms){
                            <i class="far fa-times" (click)="clear_search()"></i>
                        }
                        @else {
                            <i class="far fa-search"></i>
                        }
                    </span>
                </div>
            </div>            
                
            <div class="col-md-12">
                @for(filter of filters; track filter){
                    @if(filter.size > 0){
                        <div class="d-inline-block">
                            <button class="filter-btn mt-1 me-1" 
                                    [ngClass]="{ active: filter.active }" 
                                    (click)="toggleFilter(filter.id)" 
                                    [matTooltip]="(filter.name + '_filter_description') | translate" >
                                {{ ((filter.name+'_filter') | translate) }}
                                @if(filter.size){
                                    <span> ({{ filter.size }}) </span>
                                }
                            </button>
                        </div>
                    }
                }
                
            </div>
        </div>
        
        <hr class="border-top border-secondary border-1 opacity-25 mt-2 mb-4">
        
        <div class="row gx-0 py-1">
            <div class="d-md-flex justify-content-between align-items-center">
                <div class="d-sm-flex align-items-center justify-content-start">
                    <div class="checkbox ms-2">
                        <label>
                            <input type="checkbox" title="Select all" class="ps-2"
                                (click)="select_all()" 
                                [(ngModel)]="select_all_state">
                            {{'select_all' | translate}}
                        </label>
                    </div>
        
                    <div class="input-group px-sm-3 py-1 py-sm-0 ps-lg-5 batch-update-btn">
                        <button class="btn btn-primary dropdown-toggle" type="button" 
                                    [matMenuTriggerFor]="menu"
                                    [disabled]="selectedTeamMembers.length === 0">
                                {{ (selectedTeamMembers.length === 0 ? 'team_members_select_to_update' : 'team_members_selected_to_update') | translate : {count: selectedTeamMembers.length} }}<span class="caret"></span>
                            </button>
                        <mat-menu #menu="matMenu" class="batch-update-menu">
                            <ul class="p-0 m-0">
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('timezone')">{{ 'update_timezone' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('time')">{{ 'update_time' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('working_days', '850px')">{{ 'update_working_days' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('language')">{{ 'update_language' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('role', '1000px')">{{ 'update_role' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('holidays')">{{ 'update_holidays' | translate }}</a>
                                </li>
                                <li mat-menu-item disabled class="dropdown-divider"></li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('enable')">{{'enable_users' | translate }}</a>
                                </li>
                                <li mat-menu-item>
                                    <a class="dropdown-item" (click)="openBatchUpdateDialog('disable')">{{ 'disable' | translate }}</a>
                                </li>
                            </ul>
                        </mat-menu>
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary px-4 mb-1 align-top me-1" (click)="createTeamMember()" data-cy="add-teammember" title="{{'create_teammember' | translate}}">
                        <i class="far fa-plus"></i>
                    </button>
        
                    <button class="btn btn-default me-1" (click)="openDefaultSettingsDialog()">
                        <i class="far fa-users-cog"></i>
                    </button>
        
                    <button class="btn btn-default me-1" (click)="openBatchImportDialog()">
                        <i class="far fa-file-import"></i>
                    </button>
        
                    <button class="btn btn-default" (click)="openBatchExportDialog()">
                        <i class="far fa-file-export"></i>
                    </button>
                </div>
            </div>
        
            <team-members-list [team]="team" 
                            [members]="teammembers" 
                            [selectionEnabled]="true" 
                            [moveEnabled]="true" 
                            (onMemberChecked)="onChecked()" 
                            (onMemberChanged)="reloadTeamMembers()"></team-members-list>


            @if(!teammembers) {
                <p class="text-center">
                    <i class="far fa-refresh fa-spin fa-3x"></i>
                </p>
            }
            @else if (teammembers.length === 0) {
                <p class="text-center">
                    {{ 'search_no_teammembers' | translate }}
                </p>
            }             
        </div>
    }
</main>